import { Loader2 } from "lucide-react";

import { cn } from "@/lib/utils";

interface LoadingStateProps {
  className?: string;
  message?: string;
}

export function LoadingState({ className, message }: LoadingStateProps) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-3 py-12 text-ink-500",
        className,
      )}
    >
      <Loader2 className="h-8 w-8 animate-spin text-brand-500" />
      {message ? <span className="text-sm">{message}</span> : null}
    </div>
  );
}
